import { Box, Grid, GridItem, Image, useStyleConfig,  Button } from '@chakra-ui/react';
import {  progressiveFormStepper } from '../../components/ProgressiveFormStepper/utils';
import SectionHeader from '../SectionHeader';
import BorderBox from '../../components/Wrappers/BorderBox';
import { onLink } from '../../handlers';
import { getUsefulVars } from '../../handlers/helpers';

const ParseLetter = ({ props }) => {
  const uv = getUsefulVars(props);
  const sectionName = props.stateProps.sectionData.sectionName;
  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const questions = props.sections['questions'];
  const variant = 'wrapper';
  const styles = useStyleConfig('Parser', { variant });
  const navSection = props.navSections[sectionName];

  return (
    <BorderBox props={props} sx={{ ...styles.wrapper }}>
      <Grid sx={{ ...styles.grid }} templateColumns={2}>
        <GridItem sx={{ ...styles.grid.hero }}>
          <Image sx={{ width: [0, 0, 0, 'auto'] }} src={navSection.hero} />
        </GridItem>
        <GridItem sx={{ ...styles.grid.fieldHeader }}>
          <SectionHeader navSection={navSection} props={props} />
          <Box sx={{ ...styles.grid.fieldContent }}>
            {Object.entries(jobSeekerData).map((secParts, index) => {
                return (progressiveFormStepper(props, questions, index));
              },
            )}
          </Box>
        </GridItem>
      </Grid>
    </BorderBox>
  );
};

export default ParseLetter;